import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = ({ isCollapsed = false }) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const allNavigationItems = [
    {
      label: 'Dashboard',
      path: '/providers-dashboard',
      icon: 'LayoutDashboard',
      tooltip: 'Central hub for featured content and quick actions',
      public: true
    },
    {
      label: 'Asset Library',
      path: '/asset-library',
      icon: 'FolderOpen',
      tooltip: 'Downloadable marketing assets',
      public: true
    },
    {
      label: 'Email Campaigns',
      path: '/email-campaigns',
      icon: 'Mail',
      tooltip: 'Ready-to-use email templates',
      public: true
    },
    {
      label: 'Calendar',
      path: '/content-calendar',
      icon: 'Calendar',
      tooltip: 'Year-view content planning',
      public: true
    },
    {
      label: 'Press Releases',
      path: '/press-release-template',
      icon: 'FileText',
      tooltip: 'Template generation tool',
      public: true
    },
    {
      label: 'Best Practices',
      path: '/best-practices',
      icon: 'Lightbulb',
      tooltip: 'Social media content creation guidelines',
      public: true
    },
    {
      label: 'Marketing Support',
      path: '/schedule-marketing-support',
      icon: 'Headphones',
      tooltip: 'Schedule consultation and expert assistance',
      public: true
    },
    {
      label: 'Support Calendar',
      path: '/marketing-support-calendar',
      icon: 'CalendarCheck',
      tooltip: 'View and manage marketing support appointments',
      public: false
    },
    {
      label: 'Admin Dashboard',
      path: '/admin-dashboard',
      icon: 'Shield',
      tooltip: 'Administrative control center',
      public: false
    }
  ];

  // Filter navigation items based on authentication status
  const navigationItems = allNavigationItems?.filter(item => 
    item?.public || isAuthenticated
  );

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <>
      <button
        onClick={toggleMobileMenu}
        className="fixed top-4 left-4 z-50 lg:hidden bg-card text-foreground p-3 rounded-lg shadow-md"
        aria-label="Toggle navigation menu"
      >
        <Icon name={isMobileOpen ? 'X' : 'Menu'} size={24} />
      </button>
      <aside
        className={`fixed lg:fixed top-0 left-0 h-full bg-card border-r border-border z-100 transition-transform duration-250 ${
          isMobileOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 ${isCollapsed ? 'w-20' : 'w-60'}`}
      >
        <div className="sidebar-header flex items-center justify-center h-20 border-b border-border px-6">
        </div>

        <nav className="flex flex-col p-4 space-y-2">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              onClick={() => setIsMobileOpen(false)}
              className={`flex items-center h-12 px-4 rounded-lg transition-all duration-250 ${
                isActive(item?.path)
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-foreground hover:bg-muted hover:translate-y-[-1px]'
              }`}
              title={isCollapsed ? item?.tooltip : ''}
            >
              <Icon
                name={item?.icon}
                size={20}
                color={isActive(item?.path) ? 'var(--color-primary-foreground)' : 'currentColor'}
              />
              {!isCollapsed && <span className="ml-3 font-medium">{item?.label}</span>}
            </Link>
          ))}
        </nav>
      </aside>
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-background z-50 lg:hidden"
          onClick={toggleMobileMenu}
        />
      )}
    </>
  );
};

export default Sidebar;